// Placeholder page used by the portal's secondary screens until each one is
// implemented. Keeps navigation working end-to-end without 404s.

interface Props { title: string; subtitle?: string }

export function PortalStub({ title, subtitle }: Props) {
  return (
    <>
      <div>
        <h1 className="portal-h1">{title}</h1>
        {subtitle && <p className="portal-sub">{subtitle}</p>}
      </div>
      <div className="card" style={{ marginTop: 32 }}>
        <h3 style={{ fontSize: 17 }}>Coming next</h3>
        <p style={{ color: 'var(--fg-soft)', fontSize: 13.5, marginTop: 6, lineHeight: 1.6 }}>
          This screen is part of Phase 2. The auth, sign-up and shell are wired up;
          {' '}<strong style={{ color: 'var(--fg)' }}>{title}</strong>{' '}
          lands in the next iteration along with its API endpoints.
        </p>
      </div>
    </>
  );
}
